var _rect, _path, _rect2, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialEstimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.63916,
    y: 0.75,
    width: 13,
    height: 2,
    rx: 1,
    stroke: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7195 5.65194L15.5195 14.6519C15.5814 14.9613 15.3448 15.25 15.0293 15.25H1.24906C0.933539 15.25 0.696893 14.9613 0.758772 14.6519L2.55877 5.65194C2.60551 5.41823 2.81072 5.25 3.04906 5.25H13.2293C13.4676 5.25 13.6728 5.41823 13.7195 5.65194Z",
    stroke: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.63916,
    y: 2.75,
    width: 3,
    height: 2.5,
    stroke: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.13916,
    cy: 10.25,
    r: 2.75,
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13916 10.25V8.25C9.73916 8.25 10.1392 9.58333 10.1392 10.25H8.13916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialEstimate);
export default __webpack_public_path__ + "static/media/materialEstimate.faf0b30396227417304a1f96ec57edeb.svg";
export { ForwardRef as ReactComponent };